import styled from 'styled-components';
import { Text } from '../../Text';

export const BalancesItemValue = styled(Text).attrs({
  weight: 'medium',
})``;
